/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltypeannouncement2Inputs */

const en_channeltypeannouncement2 = /** @type {(inputs: Channeltypeannouncement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announcement`)
};

const de_channeltypeannouncement2 = /** @type {(inputs: Channeltypeannouncement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigung`)
};

/**
* | output |
* | --- |
* | "Announcement" |
*
* @param {Channeltypeannouncement2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltypeannouncement2 = /** @type {((inputs?: Channeltypeannouncement2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltypeannouncement2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltypeannouncement2(inputs)
	return de_channeltypeannouncement2(inputs)
});
export { channeltypeannouncement2 as "channelTypeAnnouncement" }